var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c("draggerBox", {
        attrs: {
          menuList: _vm.menuList,
          loading: _vm.saveLoading,
          type: 3,
          buttonName: _vm.btnName,
          auth: _vm.auth,
        },
        on: { save: _vm.onSave },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }